import React from 'react';

import styles from './styles.module.less';

/** Small colored dot used as a legend marker. */
const LegendDot: React.FC<{ color: string }> = ({ color }) => (
  <span className={styles.dot} style={{ backgroundColor: color }} aria-hidden="true" />
);

export default LegendDot;
